import { render } from "./Inquiry.vue?vue&type=template&id=4d9a553e&scoped=true"
import script from "./Inquiry.vue?vue&type=script&lang=js"
export * from "./Inquiry.vue?vue&type=script&lang=js"

import "./Inquiry.vue?vue&type=style&index=0&id=4d9a553e&scoped=true&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9a553e"]])

export default __exports__